import { V3Record } from 'data/helpers/V3Record.js'

export const ExperienceRoute = V3Record('experienceRoute', {
  experienceId: null,
  routeId: null,
  position: null
})
